import { types } from './actions';

const initialState = {
  defaultProcessId: undefined,
  isUpdatingFieldSettings: false,
  processes: [],
  showProcessSelector: true,
  showMaterialSelector: true,
  showFinishSelector: true,
  showDeliveryDateSelector: true,
  showNotesField: true,
  showReferralField: true,
  showRfqNumberField: false,
  showContactAddressFields: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FIELD_SETTINGS_FETCH_SUCCESS:
      return {
        ...state,
        defaultProcessId: payload.defaultProcessId,
        showProcessSelector: payload.showProcessSelector,
        showMaterialSelector: payload.showMaterialSelector,
        showFinishSelector: payload.showFinishSelector,
        showDeliveryDateSelector: payload.showDeliveryDateSelector,
        showNotesField: payload.showNotesField,
        showReferralField: payload.showReferralField,
        showRfqNumberField: payload.showRfqNumberField,
        showContactAddressFields: payload.showContactAddressFields,
      };
    case types.FIELD_SETTINGS_UPDATE_REQUEST:
      return {
        ...state,
        isUpdatingFieldSettings: true,
      };
    case types.FIELD_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        defaultProcessId: payload.defaultProcessId,
        isUpdatingFieldSettings: false,
        showProcessSelector: payload.showProcessSelector,
        showMaterialSelector: payload.showMaterialSelector,
        showFinishSelector: payload.showFinishSelector,
        showDeliveryDateSelector: payload.showDeliveryDateSelector,
        showNotesField: payload.showNotesField,
        showReferralField: payload.showReferralField,
        showRfqNumberField: payload.showRfqNumberField,
        showContactAddressFields: payload.showContactAddressFields,
      };
    case types.FIELD_SETTINGS_UPDATE_ERROR:
      return {
        ...state,
        isUpdatingFieldSettings: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.smartRfq.fields;

export const getDefaultProcessId = (state) => getScope(state).defaultProcessId;

export const isShowingProcessSelector = (state) =>
  getScope(state).showProcessSelector;

export const isShowingMaterialSelector = (state) =>
  getScope(state).showMaterialSelector;

export const isShowingFinishSelector = (state) =>
  getScope(state).showFinishSelector;

export const isShowingDeliveryDateSelector = (state) =>
  getScope(state).showDeliveryDateSelector;

export const isShowingNotesField = (state) => getScope(state).showNotesField;

export const isShowingReferralField = (state) =>
  getScope(state).showReferralField;

export const isUpdatingFieldSettings = (state) =>
  getScope(state).isUpdatingFieldSettings;

export const isShowingRfqNumberField = (state) =>
  getScope(state).showRfqNumberField;

export const isShowingContactAddressFields = (state) =>
  getScope(state).showContactAddressFields;
